var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('upload-document-modal',{ref:"uploadDocumentModal",attrs:{"name-document":_vm.dataEdit.documentType,"data-edit":_vm.dataEdit,"source-id":_vm.dataEdit.sourceId,"object-data":_vm.objectData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }